import type { KeyboardShortcut } from './../ricos-types';
import { createShortcut } from './../ricos-types';

export const shortcuts: KeyboardShortcut[] = [
  createShortcut({
    name: 'MoveToNextCellTab',
    description: 'ShortcutsSheet_Table_MoveToTheNextCell',
    group: 'ShortcutsSheet_Section_Table',
    keys: {
      macOs: 'Tab',
      windows: 'Tab',
    },
    enabled: false,
    command: () => {},
  }),
  createShortcut({
    name: 'MoveToNextCellArrow',
    description: 'ShortcutsSheet_Table_MoveToTheNextCell',
    group: 'ShortcutsSheet_Section_Table',
    keys: {
      macOs: 'Arrow',
      windows: 'Arrow',
    },
    enabled: false,
    command: () => {},
  }),
  createShortcut({
    name: 'MoveToPreviousCellTab',
    description: 'ShortcutsSheet_Table_MoveToThePreviousCell',
    group: 'ShortcutsSheet_Section_Table',
    keys: {
      macOs: 'Shift+Tab',
      windows: 'Shift+Tab',
    },
    enabled: false,
    command: () => {},
  }),
  createShortcut({
    name: 'MoveToPreviousCellArrow',
    description: 'ShortcutsSheet_Table_MoveToThePreviousCell',
    group: 'ShortcutsSheet_Section_Table',
    keys: {
      macOs: 'Arrow',
      windows: 'Arrow',
    },
    enabled: false,
    command: () => {},
  }),
  createShortcut({
    name: 'EnterExitCell',
    description: 'ShortcutsSheet_Table_EnterExitASelectedCell',
    group: 'ShortcutsSheet_Section_Table',
    keys: {
      macOs: 'Enter',
      windows: 'Enter',
    },
    enabled: false,
    command: () => {},
  }),
  createShortcut({
    name: 'AddNewLineShift',
    description: 'ShortcutsSheet_Table_AddANewLineWithinCell',
    group: 'ShortcutsSheet_Section_Table',
    keys: {
      macOs: 'Shift+Enter',
      windows: 'Shift+Enter',
    },
    enabled: false,
    command: () => {},
  }),
  createShortcut({
    name: 'AddNewLineAlt',
    description: 'ShortcutsSheet_Table_AddANewLineWithinCell',
    group: 'ShortcutsSheet_Section_Table',
    keys: {
      macOs: 'Alt+Enter',
      windows: 'Alt+Enter',
    },
    enabled: false,
    command: () => {},
  }),
  // createShortcut({
  //   name: 'DropLineInList',
  //   description: 'ShortcutsSheet_Table_DroppingLineWithinAList',
  //   group: 'ShortcutsSheet_Section_Table',
  //   keys: {
  //     macOs: 'Alt+Enter',
  //     windows: 'Alt+Enter',
  //   },
  //   enabled: false,
  //   command: () => {},
  // }),
  createShortcut({
    name: 'SelectContentInCell',
    description: 'ShortcutsSheet_Table_SelectingAllContentInsideCell',
    group: 'ShortcutsSheet_Section_Table',
    keys: {
      macOs: 'Meta+A',
      windows: 'Ctrl+A',
    },
    enabled: false,
    command: () => {},
  }),
  createShortcut({
    name: 'SelectColumn',
    description: 'ShortcutsSheet_Table_SelectColumn',
    group: 'ShortcutsSheet_Section_Table',
    keys: {
      macOs: 'Ctrl+Space',
      windows: 'Ctrl+Space',
    },
    enabled: false,
    command: () => {},
  }),
  createShortcut({
    name: 'SelectRow',
    description: 'ShortcutsSheet_Table_SelectRow',
    group: 'ShortcutsSheet_Section_Table',
    keys: {
      macOs: 'Shift+Space',
      windows: 'Shift+Space',
    },
    enabled: false,
    command: () => {},
  }),
  createShortcut({
    name: 'SelectTable',
    description: 'ShortcutsSheet_Table_SelectTable',
    group: 'ShortcutsSheet_Section_Table',
    keys: {
      macOs: 'Meta+Shift+A',
      windows: 'Ctrl+Shift+A',
    },
    enabled: false,
    command: () => {},
  }),
  createShortcut({
    name: 'AddNewColumnRow',
    description: 'ShortcutsSheet_Table_AddNewColumnRow',
    group: 'ShortcutsSheet_Section_Table',
    keys: {
      macOs: 'Meta+Alt++',
      windows: 'Ctrl+Alt++',
    },
    enabled: false,
    command: () => {},
  }),
  createShortcut({
    name: 'DeleteColumnRow',
    description: 'ShortcutsSheet_Table_DeleteSelectedColumnRow',
    group: 'ShortcutsSheet_Section_Table',
    keys: {
      macOs: 'Meta+Alt+-',
      windows: 'Ctrl+Alt+-',
    },
    enabled: false,
    command: () => {},
  }),
];
